import { logError } from '../'

const manageErrorCodeMsg: string[] = [
  'E0000004',
  'E0000095',
  'E0000105',
  'E0000068',
  'E0000069',
  'E0000119',
  'E0000011',
  'E0000082',
]

export const errorMsg: any = {
  requiredField(label: string) {
    return `${label} is a required field.`
  },
}

export const getErrorMsg = (key: string): string => errorMsg[key]

export const processErrorMsg = (
  error: any,
  module: string,
  moduleDescription?: string | null,
  verbose: boolean = true,
) => {
  let msg: string = 'Something went wrong! '

  /**
   * If no error object
   */
  if (!error) {
    if (verbose) {
      logError({ customMessage: msg }, module, moduleDescription)
      console.error(msg)
    }
    return msg
  }

  /**
   * Log the error
   */
  if (verbose) {
    logError(error, module, moduleDescription)
    console.error(error)
  }

  /**
   * Error object not of Okta
   */

  if (!error.errorSummary && error.message) return error.message

  /**
   * Displaying custom message for user
   */

  const foundErrorCode = manageErrorCodeMsg.find(
    (errorCode: string) => errorCode === error.errorCode,
  )

  if (foundErrorCode) return foundErrorCode

  msg = (error.errorSummary && error.errorSummary + '. ') || msg

  if (error.errorCauses && error.errorCauses.length) {
    for (let e of error.errorCauses) {
      msg += e.errorSummary + '. '
    }
  }

  /**
   * if double dots appears after concatenation in above then replace it to one dot.
   * This inconsistency is in okta error message where sometime dot appear and
   * sometimes not!
   */
  const formattedError = msg.split('..').join('.')
  if (verbose) {
    console.error(formattedError)
  }

  return formattedError
}
